import styled from 'styled-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

// enums
import { ArrowDirection } from '../../enums';

export const ImageColumn = styled.div`
    position: relative;
    width: 100%;
    flex: 1;
    border-radius: 15px;
    min-height: 324px;

    @media (max-width: ${BreakPoints.PHONE}) {
        min-height: 258px;
    }
`;

export const VehicleImage = styled.img`
    width: 100%;
    height: 100%;
    display: block;
    /* Dealer photos arrive at mixed aspect ratios; contain keeps every photo whole
       (no cropped merchandising banners) and undistorted at any viewport width. */
    object-fit: contain;
    object-position: center;
    background: #eef0f2;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 15px;
`;

/* ── Prev / Next arrow buttons ── */
export const ArrowButton = styled.button<{ direction: ArrowDirection }>`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${({ direction }) => (direction === ArrowDirection.Prev ? 'left: 8px;' : 'right: 8px;')}
    background: transparent;
    border: none;
    border-radius: 0;
    width: 4px;
    font-size: 60px;
    font-weight: 400;
    color: ${({ theme }) => theme.uiBricks?.modalBackgroundColor};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2;
    line-height: 1;
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);

    &:hover {
        background: transparent;
        opacity: 0.8;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        font-size: 48px;
    }
`;

/* ── Expand / fullscreen button ── */
export const ExpandButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.uiBricks.modalBackgroundColor};
    background: rgba(0, 0, 0, 0.45);
    color: ${({ theme }) => theme.uiBricks.modalBackgroundColor};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 3;
    padding: 0;
    transition: background 0.2s;

    &:hover {
        background: rgba(0, 0, 0, 0.65);
    }

    svg {
        width: 22px;
        height: 22px;
    }
`;

/* ── Fullscreen overlay ── */
export const FullscreenOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
`;

export const PreviewImageWrapper = styled.div`
    background: ${({ theme }) => theme.uiBricks?.modalBackgroundColor || '#ffffff'};
    margin-top: 72px;
    padding: 60px;
    width: 100%;
    height: 78%;
    position: relative;
    display: flex;
    justify-content: center;
`;

export const FullscreenCloseButton = styled.button`
    position: absolute;
    top: 20px;
    right: 24px;
    background: transparent;
    border: none;
    color: ${({ theme }) => theme.uiBricks.labelFontColor || '#000000'};
    font-size: 36px;
    cursor: pointer;
    z-index: 10000;
    line-height: 1;

    &:hover {
        opacity: 0.7;
    }
`;

export const FullscreenImage = styled.img`
    width: auto;
    height: auto;
    max-width: 90vw;
    max-height: 85vh;
    object-fit: contain;
`;

export const FullscreenArrowButton = styled.button<{ direction: ArrowDirection }>`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${({ direction }) => (direction === ArrowDirection.Prev ? 'left: 24px;' : 'right: 24px;')}
    background: transparent;
    border: none;
    font-size: 72px;
    font-weight: 400;
    color: ${({ theme }) => theme.uiBricks?.labelFontColor || '#000000'};
    cursor: pointer;
    z-index: 10000;
    line-height: 1;

    &:hover {
        opacity: 0.7;
    }
`;

export const FullscreenCounter = styled.div`
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    color: ${({ theme }) => theme.uiBricks?.labelFontColor || '#000000'};
    font-size: 14px;
    font-weight: 700;
    z-index: 10000;
`;

/* ── Thumbnail strip ── */
export const ThumbnailStrip = styled.div`
    display: flex;
    gap: 4px;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const Thumbnail = styled.img<{ $active?: boolean }>`
    min-width: 92px;
    height: 58px;
    object-fit: cover;
    border-radius: 15px;
    cursor: pointer;
    opacity: ${({ $active }) => ($active ? 1 : 0.8)};
    transition: opacity 0.2s, border-color 0.2s;

    &:hover {
        opacity: 1;
    }

    @media (max-width: ${BreakPoints.TABLET}) {
        min-width: 142px;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        min-width: 69px;
        height: 46px;
    }
`;
